'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _odataUri = require('../utils/odata-uri');

var _odataUri2 = _interopRequireDefault(_odataUri);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
// function getFilterValue(column, def) {
// 	let fieldName = column.data || column.name;
// 	fieldName = fieldName.replace('.', '/');
// 	const columnFilter = column.search.value;
//
// 	if (column.searchable && columnFilter !== null && columnFilter !== "" && columnFilter !== "~") {
// 		switch (def.type) {
// 			case 'date':
// 			case 'float':
// 			case 'int': {
// 				const fnFormatValue = (def.type === 'date') ? v => (moment(v, ["L LT", "L"])).toISOString() : v => v;
//
// 				// Currently, we cannot use global search for date and numeric fields (exception on the OData service side)
// 				// However, individual column filters are supported in form lower~upper
// 				if (columnFilter.indexOf("~") > -1) {
// 					const ranges = columnFilter.split("~");
// 					const rangeQuery = [];
// 					if (ranges[0]) {
// 						rangeQuery.push("(" + fieldName + " ge " + fnFormatValue(ranges[0]) + ")");
// 					}
// 					if (ranges[1]) {
// 						rangeQuery.push("(" + fieldName + " le " + fnFormatValue(ranges[1]) + ")");
// 					}
// 					return "(" + rangeQuery.join(" and ") + ")";
// 				} else {
// 					return "(" + fieldName + " eq " + fnFormatValue(columnFilter) + ")";
// 				}
// 			}
// 			case 'boolean':
// 			case 'bool':
// 				if (columnFilter === 'true' || columnFilter === 'false') {
// 					return filters.equals(fieldName, columnFilter === 'true');
// 				} else {
// 					return null;
// 				}
// 			case 'enum':
// 				return filters.equals(fieldName, columnFilter);
//
// 			case 'lookup':
// 				return def.isArray
// 						? filters.anyEquals(fieldName, parseInt(columnFilter, 10), 'id')
// 						: filters.equals(fieldName, parseInt(columnFilter, 10), 'id');
//
// 			case 'string':
// 				return def.isArray
// 						? filters.anyContains(fieldName, columnFilter)
// 						: filters.contains(fieldName, columnFilter);
// 			case 'html':
// 			default:
// 				return filters.contains(fieldName, columnFilter);
// 		}
// 	}
// 	return null;
// }

function buildRequestParams(data, table) {
	var api = _jquery2.default.fn.dataTable.Api(table);
	var d = (0, _odataUri2.default)(
	// filter
	data.columns.map(function (v, i) {
		return api.column(i).renderer().getFilterExpression();
	}).filter(function (v) {
		return !!v;
	}),
	// orderBy
	data.order ? data.order.filter(function (v) {
		return data.columns[v.column].orderable;
	}).map(function (v) {
		return { property: api.column(v.column).renderer().orderByProp.replace('.', '/'), dir: v.dir || 'asc' };
	}) : [],
	// skip
	data.start,
	// top
	data.length,
	// select
	null,
	// expand
	api.columns().map().filter(function (c) {
		return c.options().navigationProperty;
	}).map(function (c) {
		return c.options().data;
	}).filter(function (v, i, a) {
		return a.indexOf(v) === i;
	}));

	// custom filters / external filters
	var customFilters = table.oInit.customFilters;
	if (typeof customFilters === 'string') {
		var $filters = (0, _jquery2.default)(customFilters);
		$filters.each(function () {
			d[(0, _jquery2.default)(this).attr('name')] = (0, _jquery2.default)(this).val();
		});
	}

	return d;
}

function readResponseData(data) {
	data.recordsTotal = data["@odata.count"] || data["odata.count"] || data.__count || 0;
	data.recordsFiltered = data.recordsTotal;
	return data.value;
}

exports.default = {
	data: buildRequestParams,
	dataSrc: readResponseData
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/odata.js
// module id = 485
// module chunks = 0